export default function StatusIndicator({ tone, children, className = "" }) {
  const toneClass = ["positive", "published", "active"].includes(tone)
    ? "text-green-500"
    : ["negative", "cancelled", "forced_sold_out"].includes(tone)
      ? "text-red-500"
      : ["neutral", "pending_approval", "upcoming"].includes(tone)
        ? "text-amber-500"
        : "text-gray-500";

  return (
    <p className={`flex min-w-0 gap-1 pt-1 text-xs items-center ${toneClass} ${className}`}>
      <span className="shrink-0 leading-none">●</span>
      <span className="min-w-0 truncate uppercase tracking-wide">
        {children}
      </span>
    </p>
  );
}